import { useEffect, useState } from 'react';

/**
 * Retorna `value` após `delayMs` sem alterações — útil pra throttle de
 * input controlado disparando queries de rede a cada tecla.
 *
 * <p>Padrão idêntico ao `useDebounced` que existe inline em
 * `AdicionarProdutoDialog.tsx`, `MultiSelectFornecedor.tsx` e `useMetaSugestao.ts`
 * (cópias antigas que podem migrar pra cá em cleanup futuro).</p>
 */
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
